import { lazy, Suspense } from "react";
import CircularLoader from "../../customs/loader/main";
const Main = lazy(() => import("../../components/settings/approvalSetup/main"));

const ApprovalSetup = () => {
  return (
        <Suspense fallback={<CircularLoader />}>
          <Main />
        </Suspense>
  );
};

export default ApprovalSetup;


